const register = {
  loginCredentials: "Login Credentials",
  companyInformation: "Company Information",
  contactDetails: "Contact Details",
  businessName: "Business Name",
  businessAddress: "Business Address",
  registrationCode: "Registration Code",
  businessRegistrationNumber: "Business Registration Number",
  websiteUrl: "Website URL",
  mobilePhone: "Mobile Phone",
  regionStateProvince: "Region/State/Province",
  legalTitle: "Legal Title",
  city: "City",
  postalCode: "Postal Code",
  registrationSuccess: "Registration Success.",
  pleaseWaitFewMomentsAndYouWillBeRedirectedToHome:
    "Please wait a few moments and you will be redirected to the home page.",
};

export default register;
